/**
 * @class UserGroup
 */
export default class UserGroup {
    /**
     * @param {Number} id
     * @param {Number} translation
     * @param {Number} name
     * @param {Number} priority
     * @param {Number} translate
     * @param {Number} default
     */
    constructor(id, translation, name, priority = -99, translate = false, def = false) {
        this._priority = priority;
        this._translate = translate;
        this._default = def;
        this._id = id;
        this._translation = translation;
        this._name = name;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - UserGroup");
        }
    }

    /**
     * @return {Number}
     */
    get priority() {
        return this._priority;
    }

    /**
     * @param {Number} priority
     */
    set priority(priority) {
        this._priority = priority;
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Number}
     */
    get translate() {
        return this._translate;
    }

    /**
     * @param {Number} translate
     */
    set translate(translate) {
        this._translate = translate;
    }

    /**
     * @return {Number}
     */
    get default() {
        return this._default;
    }

    /**
     * @param {Number} default
     */
    set default(def) {
        this._default = def;
    }

    /**
     * @return {Number}
     */
    get translation() {
        return this._translation;
    }

    /**
     * @param {Number} translation
     */
    set translation(translation) {
        this._translation = translation;
    }

    /**
     * @return {Number}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {Number} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    toString() {
        return "UserGroup (" + this._priority + ")";
    }
}
